import React from 'react';
import { connect } from 'react-redux';
import './TopicsMenu.css';
import { changeTopic } from '../../../../redux/actions';
import { TOPIC_ALL, TOPICS, PATH } from '../../../../constants';
import * as textHelper from '../../../../utils/TextHelper';

const topicScroll = () => {
  // todo - currently disabled
  // document.getElementById('subtopic-menu').scrollIntoView();
};

const TopicsMenu = ({ category, categoryData, actualTopic, switchTopic }) => {
  const topics = [TOPIC_ALL];
  const counter = {};
  // count items for each topic
  categoryData.forEach((item) => {
    item[1].topic.forEach((topic) => {
      if (topic.length > 0) {
        const topicIndex = TOPICS.indexOf(topic);
        if (topicIndex >= 0) {
          if (!counter[topicIndex]) {
            counter[topicIndex] = 1;
          } else {
            counter[topicIndex] += 1;
          }
        }
      }
    });
  });
  for (let i = 0; i < TOPICS.length; i += 1) {
    if (counter[i]) {
      topics.push(TOPICS[i]);
    }
  }

  // create elements
  const topicElements = topics.map((topic) => {
    let btnClass = 'topic';
    if (topic === actualTopic) {
      btnClass = `${btnClass} selected`;
    }
    return (
      <button
        key={encodeURIComponent(topic)}
        className={btnClass}
        onClick={() => {
          switchTopic(topic);
          topicScroll();
        }}
      >
        <div className="bg" />
        <img
          className="ico"
          src={`${PATH.IMG}ico/topic/ico-topic-${TOPICS.indexOf(topic)}.png`}
          alt={topic}
        />
        <div className="label">
          {textHelper.formatText(topic).toUpperCase()}
        </div>
      </button>
    );
  });

  return (
    <div className="topics-menu">
      <img
        className="deco-top"
        src={`${PATH.IMG}deco/deco-top-${category}.png`}
        alt={categoryData.title}
      />
      {topicElements}
    </div>
  );
};

const mapStateToProps = state => ({
  category: state.dataCategory.category,
  categoryData: state.dataCategory.data,
  actualTopic: state.dataCategory.topic,
});

const mapDispatchToProps = dispatch => ({
  switchTopic: topic => dispatch(changeTopic(topic)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopicsMenu);



// WEBPACK FOOTER //
// ./src/components/App/CategoryPage/TopicsMenu/TopicsMenu.js